import type { WebTemplateHref } from '@generalTypes/apiTypes';
import { loadWebConfigurations } from '@newStore/documentApi/documentApiState';
import { selectTitleWithDescriptionNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { NodeType, RequiredType, type RootNodeConfig } from '@nodeTypeConfig/configTypes';
import { authorsComponent } from '@nodeTypeConfig/helpers/editComponents/authorsComponent';
import { publishComponent } from '@nodeTypeConfig/helpers/editComponents/publishComponent';
import { asideWebBasicConfiguration } from '@nodeTypeConfig/helpers/editComponents/webConfigComponents';
import { webSitesWwwHref } from '@store/api/apiRoutes';
import constants from '../../../reduxLoop/constants/constants';
import { settings } from '../../settings';
import {
  wwwDefaultBuildingBlocks,
  wwwOmslagAndTegelFotoComps,
  wwwTitleAndDescriptionComps,
} from './wwwGenericConfigProps';

export const JOB_OFFER: RootNodeConfig = {
  nodeSelector: selectTitleWithDescriptionNode,
  validationRules: [],
  information: {
    definiteArticle: true,
    single: 'Vacature',
    plural: 'Vacatures',
    icon: require('../../../../img/icons/document.svg'),
  },
  onLoadActions: [loadWebConfigurations()],
  webconfiguration: {
    type: 'WWW_NEWS_DETAIL',
    website: {
      href: webSitesWwwHref,
    },
    template: {
      href: '/web/templates/514777b4-4657-4590-835e-7ff9d6e99b22' as WebTemplateHref,
    },
  },
  websiteHref: webSitesWwwHref,
  createModal: {
    authors: {
      required: RequiredType.ERROR,
      addUser: false,
      queryParams: constants.jobofferAuthorsParameters,
      label: 'Instelling',
      errorMessageKey: 'createContentModal.institution',
    },
  },
  buildingBlocks: wwwDefaultBuildingBlocks,
  tocTypes: [NodeType.SECTION],
  edit: [
    ...wwwTitleAndDescriptionComps,
    ...wwwOmslagAndTegelFotoComps,
    {
      ...authorsComponent,
      label: 'Instelling',
      options: {
        queryParams: constants.jobofferAuthorsParameters,
      },
    },
    publishComponent,
  ],
  webTab: asideWebBasicConfiguration,
  customEditorOptions: {
    hideTermButton: true,
  },
  isCreatable: true,
  isSearchable: true,
  isImportable: false,
  allowSuggestions: false,
  websiteEdition: [
    {
      domain: settings.domains.www,
    },
  ],
};
